module.exports = __webpack_public_path__ + "static/media/icon_smiley_face.e764f72d.svg";